import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { VerificationPage } from './pages/VerificationPage';
import { TechnicianLogin } from './pages/TechnicianLogin';

// Main app will be imported here
interface AppRouterProps {
    MainApp: React.ComponentType;
}

export const AppRouter: React.FC<AppRouterProps> = ({ MainApp }) => {
    return (
        <BrowserRouter>
            <ErrorBoundary>
                <Routes>
                    {/* Technician login page */}
                    <Route path="/tech-login" element={<TechnicianLogin />} />

                    {/* Verification route - standalone page for technicians */}
                    <Route path="/verify/:token" element={<VerificationPage />} />

                    {/* Main application route */}
                    <Route path="/*" element={<MainApp />} />
                </Routes>
            </ErrorBoundary>
        </BrowserRouter>
    );
};
